import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FinancialDataService } from './../../../services/financialData.service';
import { environment } from '../../../../environments/environment';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionLinks } from '../../../enums/permissionLinks';
import { CompanyMasterService } from '../../../services/companymaster.service';
import { ChatbotService } from 'src/app/services/chatbot.service';

declare var $: any;
declare var Chart: any;

@Component({
  selector: 'app-financials',
  templateUrl: './financials.component.html',
  styleUrls: ['./financials.component.css'],
})
export class FinancialsComponent implements OnInit, AfterViewInit {
  // Main tab state
  activeMainTab: string = 'profitAndLoss'; // 'profitAndLoss' or 'balanceSheet'
  
  // Profit & Loss sub-tabs
  activePLTab: string = 'quarterly'; // 'quarterly' or 'annual'
  
  // Type tabs (Standalone/Consolidated) - for both PL and BS
  activeTypeTab: string = 'standalone'; // 'standalone' or 'consolidated'
  
  // Loading states
  isLoadingPLQuarterly = false;
  isLoadingPLAnnual = false;
  isLoadingBS = false;
  isLoadingBSStandalone = false;
  isLoadingBSConsolidated = false;
  
  // Data properties
  balanceSheetStandaloneData: any[] = [];
  balanceSheetConsolidatedData: any[] = [];
  balanceSheetStandaloneHeaders: string[] = [];
  balanceSheetConsolidatedHeaders: string[] = [];
  plAnnualData: any;
  bsData: any;
  plQuarterlyDataStandalone: any;
  plQuarterlyDataConsolidated: any;
  plQuarterlyStandaloneHeaders: string[] = [];
  plQuarterlyConsolidatedHeaders: string[] = [];
  plAnnualDataStandalone: any[] = [];
  plAnnualDataConsolidated: any[] = [];
  plAnnualStandaloneHeaders: string[] = [];
  plAnnualConsolidatedHeaders: string[] = [];
  financialDataStandalone = PermissionLinks.financialDataStandalone;
  financialDataConsolidated = PermissionLinks.financialDataConsolidated;
  isCompanyListed: any;
  isFinancialResults: any;
  arrangedDataStandalone: any[] = [];
  arrangedDataConsolidated: any[] = [];
headerDatesStandalone: string[] = [];
dateHeadersConsolidated: string[] = [];
  isDataLoaded = false;

  // Feature flag — driven by environment.useFinancialExtractAPI
  useNewApi: boolean = environment.useFinancialExtractAPI;

  // true when the logged-in user has the 'Admin' or 'All Role' role
  isAdmin: boolean = false;

  // ── FMP Symbol (direct API) ──────────────────────────────────────────────
  fmpSymbol: string = '';
  fmpSymActiveTab: string = 'income';       // 'income' | 'bs' | 'pnl' | 'bspdf'
  fmpSymIncomePeriod: string = 'annual';    // 'annual' | 'quarterly'
  fmpSymBsPeriod: string = 'annual';
  fmpSymIsLoadingIncome: boolean = false;
  fmpSymIsLoadingBs: boolean = false;
  fmpSymIncomeError: string = '';
  fmpSymBsError: string = '';
  fmpSymIncomeData: any = null;
  fmpSymBsData: any = null;
  fmpIncomeDisplayRows: any[] = [];
  fmpIncomeDisplayKeys: string[] = [];
  fmpBsDisplayRows: any[] = [];
  fmpBsDisplayKeys: string[] = [];

  // ── FMP PDF P&L state ────────────────────────────────────────────────────
  fmpActiveTab: string = 'pnl';
  fmpActivePnlTab: string = 'quarterly';
  fmpPnlPdfId: string = '';
  fmpIsUploadingPnl: boolean = false;
  fmpIsLoadingPnlQuarterly: boolean = false;
  fmpIsLoadingPnlYearly: boolean = false;
  fmpPnlUploadError: string = '';
  fmpPnlQuarterlyData: any = null;
  fmpPnlYearlyData: any = null;
  fmpPnlQuarterlyColumns: string[] = [];
  fmpPnlQuarterlyRows: any[] = [];
  fmpPnlYearlyColumns: string[] = [];
  fmpPnlYearlyRows: any[] = [];

  // ── FMP PDF Balance Sheet state ──────────────────────────────────────────
  fmpBsPdfId: string = '';
  fmpIsUploadingBs: boolean = false;
  fmpIsLoadingBs: boolean = false;
  fmpBsUploadError: string = '';
  fmpBsData: any = null;
  fmpBsColumns: string[] = [];
  fmpBsRows: any[] = [];

  allowedItems = [
   'Revenue from operations',
   'Other income',
   'Total income',
   'Total Expenses',  
   'Profit before tax, finance cost, depreciation and amortization expenses',
   'Profit before tax, finance cost, depreciation and amortization expenses from continuing operations',
   'Profit before tax',
   'a) Current tax',
   'b) Deferred tax charge/ (credit)',
   'Profit for the period / year',
   'Profit after tax for the period/year from continuing operations',
   'Paid up equity share capital',
   'Earnings per equity share',
   'Earnings per equity share for continuing and discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)',
   'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)',
   'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)'
 ];
  constructor(
    private chatbotService: ChatbotService,
    private companyMasterService: CompanyMasterService,
    private cdr: ChangeDetectorRef
  ) { }

  // Helper function to set Equity value to 3,962 for all years
  setEquityValue(data: any[], headers: string[]) {
    if (!data || !Array.isArray(data) || !headers || !Array.isArray(headers)) {
      return;
    }
    
    // Find the Equity row
    const equityRow = data.find((row: any) => {
      if (row && row.label) {
        const normalizedLabel = this.normalizeItemName(row.label);
        const normalizedEquity = this.normalizeItemName('Paid up equity share capital');
        return normalizedLabel === normalizedEquity || 
               normalizedLabel === this.normalizeItemName('Equity') ||
               row.label === 'Equity' ||
               row.label === 'Paid up equity share capital';
      }
      return false;
    });
    
    if (equityRow && headers.length > 0) {
      // Set 3,962 for all year headers
      headers.forEach(header => {
        equityRow[header] = '3,962';
      });
    }
  }

  ngOnInit() {
    $('body').addClass('dashboard-page dark-theme');
    this.isCompanyListed = localStorage.getItem('isCompanyListed');
    this.isFinancialResults = localStorage.getItem('isFinancialResults');
    this.fmpSymbol = localStorage.getItem('Symbol') || '';

    try {
      const userRoles: string[] = JSON.parse(localStorage.getItem('user')).Roles.map((r: any) => r.RoleName);
      this.isAdmin = userRoles.includes('Admin') || userRoles.includes('All Role');
    } catch (_) {
      this.isAdmin = false;
    }
  }

  ngAfterViewInit() {
    // Set up modal event listener to load data when modal is shown
    setTimeout(() => {
      const modalEl = $('#FinancialsModal');
      if (modalEl && modalEl.length) {
        // Remove any existing listeners to avoid duplicates
        modalEl.off('shown.bs.modal');
        // Add listener for when modal is shown
        modalEl.on('shown.bs.modal', () => {
          if (!this.isDataLoaded) {
            this.loadFinancialData();
          }
        });
        
        // Check if modal is already shown (in case it was opened before component initialized)
        if (modalEl.hasClass('show') || modalEl.is(':visible')) {
          if (!this.isDataLoaded) {
            this.loadFinancialData();
          }
        }
      } else {
        // If modal doesn't exist, load data immediately (for direct navigation)
        if (!this.isDataLoaded) {
          this.loadFinancialData();
        }
      }
    }, 200);
  }

  loadFinancialData() {
    if (this.isDataLoaded) {
      return;
    }

    this.companyMasterService.ensureStockSymbol().then((symbol) => {
      if (!symbol) {
        this.fmpSymbol = '';
        this.isDataLoaded = true;
        return;
      }

      this.fmpSymbol = symbol;

      if (this.useNewApi) {
        this.loadFmpIncomeStatement(symbol);
        this.loadFmpBalanceSheetFmpBySymbol(symbol);
        this.isDataLoaded = true;
        return;
      }

      this.getPLQuarterlyStandalone(symbol);
      this.getPLQuarterlyConsolidated(symbol);
      this.getPLAnnualStandalone(symbol);
      this.getPLAnnualConsolidated(symbol);
      this.getBalanceSheetStandalone(symbol);
      this.getBalanceSheetConsolidated(symbol);
      this.isDataLoaded = true;
      this.loadData();
    });
  }

  // ── FMP: Income Statement & Balance Sheet by symbol ──────────────────────

  loadFmpIncomeStatement(symbol: string) {
    if (!symbol) { return; }
    this.fmpSymIsLoadingIncome = true;
    this.fmpSymIncomeError = '';
    this.chatbotService.getFmpIncomeStatement(symbol).subscribe(
      (response: any) => {
        this.fmpSymIncomeData = (response && response.data) ? response.data : response;
        this.fmpSymIsLoadingIncome = false;
        this._refreshIncomeDisplay();
      },
      (error: any) => {
        this.fmpSymIncomeError = 'Unable to load income statement. Please try again.';
        this.fmpSymIsLoadingIncome = false;
      }
    );
  }

  loadFmpBalanceSheetFmpBySymbol(symbol: string) {
    if (!symbol) { return; }
    this.fmpSymIsLoadingBs = true;
    this.fmpSymBsError = '';
    this.chatbotService.getFmpBalanceSheetBySymbol(symbol).subscribe(
      (response: any) => {
        this.fmpSymBsData = (response && response.data) ? response.data : response;
        this.fmpSymIsLoadingBs = false;
        this._refreshBsDisplay();
      },
      (error: any) => {
        this.fmpSymBsError = 'Unable to load balance sheet. Please try again.';
        this.fmpSymIsLoadingBs = false;
      }
    );
  }

  onFmpSymIncomePeriodChange(period: string) {
    this.fmpSymIncomePeriod = period;
    this._refreshIncomeDisplay();
  }

  onFmpSymBsPeriodChange(period: string) {
    this.fmpSymBsPeriod = period;
    this._refreshBsDisplay();
  }

  private _refreshIncomeDisplay() {
    const rows = this.fmpSymIncomePeriod === 'annual'
      ? (this.fmpSymIncomeData?.annual || [])
      : (this.fmpSymIncomeData?.quarterly || []);
    this.fmpIncomeDisplayRows = Array.isArray(rows) ? rows : [];
    this.fmpIncomeDisplayKeys = this._getFmpDisplayKeys(this.fmpIncomeDisplayRows);
  }

  private _refreshBsDisplay() {
    const rows = this.fmpSymBsPeriod === 'annual'
      ? (this.fmpSymBsData?.annual || [])
      : (this.fmpSymBsData?.quarterly || []);
    this.fmpBsDisplayRows = Array.isArray(rows) ? rows : [];
    this.fmpBsDisplayKeys = this._getFmpDisplayKeys(this.fmpBsDisplayRows);
  }

  private _getFmpDisplayKeys(rows: any[]): string[] {
    if (!rows || rows.length === 0) { return []; }
    const excluded = new Set([
      'symbol', 'reportedCurrency', 'cik', 'fillingDate', 'acceptedDate',
      'link', 'finalLink', 'period', 'calendarYear'
    ]);
    return Object.keys(rows[0]).filter(k => !excluded.has(k));
  }

  formatFmpFieldName(key: string): string {
    if (key === 'date') { return 'Period'; }
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .replace(/^./, s => s.toUpperCase())
      .trim();
  }

  formatFmpFinancialValue(val: any, key: string): string {
    if (val == null || val === '') { return '—'; }
    if (key === 'date') { return String(val); }
    if (typeof val === 'boolean') { return val ? 'Yes' : 'No'; }
    if (typeof val === 'number') {
      if (Math.abs(val) >= 10000000) {
        const crore = val / 10000000;
        return crore.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' Cr';
      }
      if (Math.abs(val) >= 100000) {
        const lakh = val / 100000;
        return lakh.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' L';
      }
      return val.toLocaleString('en-IN', { maximumFractionDigits: 2 });
    }
    return String(val);
  }

  isFmpHighlightRow(key: string): boolean {
    const highlighted = new Set([
      'revenue', 'netIncome', 'grossProfit', 'operatingIncome', 'ebitda',
      'totalAssets', 'totalLiabilities', 'totalEquity', 'totalStockholdersEquity',
      'netIncomeRatio', 'grossProfitRatio'
    ]);
    return highlighted.has(key);
  }

  // ── FMP: P&L PDF upload ──────────────────────────────────────────────────
  onFmpPnlPdfChange(event: any) {
    const file: File = event.target.files[0];
    if (!file) { return; }
    this.fmpPnlUploadError = '';
    this.fmpIsUploadingPnl = true;
    this.chatbotService.extractPnlPdf(file).subscribe(
      (response: any) => {
        this.fmpPnlPdfId = response.pdf_id;
        this.fmpIsUploadingPnl = false;
        this.loadFmpPnlQuarterly();
        this.loadFmpPnlYearly();
      },
      (error: any) => {
        this.fmpPnlUploadError = 'Failed to upload PDF. Please try again.';
        this.fmpIsUploadingPnl = false;
      }
    );
  }

  loadFmpPnlQuarterly() {
    if (!this.fmpPnlPdfId) { return; }
    this.fmpIsLoadingPnlQuarterly = true;
    this.chatbotService.getPnlQuarterly(this.fmpPnlPdfId).subscribe(
      (response: any) => {
        this.fmpPnlQuarterlyData = response;
        const parsed = this.parseFmpTableResponse(response);
        this.fmpPnlQuarterlyColumns = parsed.columns;
        this.fmpPnlQuarterlyRows = parsed.rows;
        this.fmpIsLoadingPnlQuarterly = false;
      },
      (error: any) => {
        this.fmpIsLoadingPnlQuarterly = false;
      }
    );
  }

  loadFmpPnlYearly() {
    if (!this.fmpPnlPdfId) { return; }
    this.fmpIsLoadingPnlYearly = true;
    this.chatbotService.getPnlYearly(this.fmpPnlPdfId).subscribe(
      (response: any) => {
        this.fmpPnlYearlyData = response;
        const parsed = this.parseFmpTableResponse(response);
        this.fmpPnlYearlyColumns = parsed.columns;
        this.fmpPnlYearlyRows = parsed.rows;
        this.fmpIsLoadingPnlYearly = false;
      },
      (error: any) => {
        this.fmpIsLoadingPnlYearly = false;
      }
    );
  }

  // ── FMP: Balance Sheet PDF upload ────────────────────────────────────────
  onFmpBsPdfChange(event: any) {
    const file: File = event.target.files[0];
    if (!file) { return; }
    this.fmpBsUploadError = '';
    this.fmpIsUploadingBs = true;
    this.chatbotService.extractBalanceSheetPdf(file).subscribe(
      (response: any) => {
        this.fmpBsPdfId = response.pdf_id;
        this.fmpIsUploadingBs = false;
        this.loadFmpBalanceSheet();
      },
      (error: any) => {
        this.fmpBsUploadError = 'Failed to upload PDF. Please try again.';
        this.fmpIsUploadingBs = false;
      }
    );
  }

  loadFmpBalanceSheet() {
    if (!this.fmpBsPdfId) { return; }
    this.fmpIsLoadingBs = true;
    this.chatbotService.getBalanceSheetData(this.fmpBsPdfId).subscribe(
      (response: any) => {
        this.fmpBsData = response;
        const parsed = this.parseFmpTableResponse(response);
        this.fmpBsColumns = parsed.columns;
        this.fmpBsRows = parsed.rows;
        this.fmpIsLoadingBs = false;
      },
      (error: any) => {
        this.fmpIsLoadingBs = false;
      }
    );
  }

  /**
   * Normalise various response shapes from the extraction API into
   * { columns: string[], rows: { label: string, [col]: any }[] }.
   *
   * The API may return:
   *   - { extracted_data: { [date]: { [lineItem]: value } } }
   *   - { tableData: [ { label, [year]: value } ] }
   *   - a flat object/array
   */
  parseFmpTableResponse(response: any): { columns: string[], rows: any[] } {
    if (!response) { return { columns: [], rows: [] }; }

    // Shape: { extracted_data: { dateKey: { lineItem: value } } }
    if (response.extracted_data && typeof response.extracted_data === 'object') {
      const dateKeys = Object.keys(response.extracted_data);
      const lineItems = new Set<string>();
      dateKeys.forEach(dk => Object.keys(response.extracted_data[dk]).forEach(li => lineItems.add(li)));
      const rows = Array.from(lineItems).map(li => {
        const row: any = { label: li };
        dateKeys.forEach(dk => { row[dk] = response.extracted_data[dk][li]; });
        return row;
      });
      return { columns: dateKeys, rows };
    }

    // Shape: { tableData: [ { label, yearCol1, yearCol2, ... } ] }
    if (response.tableData && Array.isArray(response.tableData) && response.tableData.length > 0) {
      const colSet = new Set<string>();
      response.tableData.forEach((r: any) => Object.keys(r).filter(k => k !== 'label').forEach(k => colSet.add(k)));
      return { columns: Array.from(colSet), rows: response.tableData };
    }

    // Shape: flat array of objects (rows already)
    if (Array.isArray(response) && response.length > 0 && response[0].label) {
      const colSet = new Set<string>();
      response.forEach((r: any) => Object.keys(r).filter(k => k !== 'label').forEach(k => colSet.add(k)));
      return { columns: Array.from(colSet), rows: response };
    }

    return { columns: [], rows: [] };
  }

  onMainTabChange(tab: string) {
    this.activeMainTab = tab;
    // Reset sub-tabs when switching main tabs
    if (tab === 'profitAndLoss') {
      this.activePLTab = 'quarterly';
    } else {
      // Balance sheet only needs type (standalone/consolidated)
      this.activeTypeTab = 'standalone';
    }
    this.loadData();
    
    // Initialize charts when switching to balance sheet
    if (tab === 'balanceSheet') {
      setTimeout(() => {
        this.initializeBalanceSheetCharts(this.activeTypeTab);
      }, 600);
    }
  }

  onPLTabChange(tab: string) {
    this.activePLTab = tab;
    this.loadData();
    // Initialize charts when switching tabs
    if (this.activeMainTab === 'profitAndLoss') {
      setTimeout(() => {
        if (tab === 'quarterly') {
          this.initializeQuarterlyPLCharts(this.activeTypeTab);
        } else if (tab === 'annual') {
          this.initializeAnnualPLCharts(this.activeTypeTab);
        }
      }, 600);
    }
  }

  

  onTypeTabChange(tab: string) {
    this.activeTypeTab = tab;
    this.loadData();
    // Initialize charts when switching type tabs
    if (this.activeMainTab === 'profitAndLoss') {
      setTimeout(() => {
        if (this.activePLTab === 'quarterly') {
          this.initializeQuarterlyPLCharts(tab);
        } else if (this.activePLTab === 'annual') {
          this.initializeAnnualPLCharts(tab);
        }
      }, 600);
    } else if (this.activeMainTab === 'balanceSheet') {
      setTimeout(() => {
        this.initializeBalanceSheetCharts(tab);
      }, 600);
    }
  }

  loadData() {
    if (this.activeMainTab === 'profitAndLoss') {
      if (this.activePLTab === 'quarterly') {
        this.loadPLQuarterly();
      } else {
        this.loadPLAnnual();
      }
    } else {
      this.loadBS();
    }
  }

  loadPLQuarterly() {
    this.isLoadingPLQuarterly = true;
    // TODO: Implement API call for quarterly P&L data
    setTimeout(() => {
      this.isLoadingPLQuarterly = false;
    }, 500);
  }
  getYearFromDate(dateStr: string): string {
    return new Date(dateStr).getFullYear().toString();
  }
  getPLQuarterlyStandalone(symbol){
    this.chatbotService.getPLQuarterlyStandalone(symbol).subscribe(
      (response: any) => {
        // console.log('PL Quarterly Standalone Response:', response);
        
        // Check if extracted_data exists and is an object
        if (!response || !response.extracted_data || typeof response.extracted_data !== 'object') {
          // console.warn('Invalid or missing extracted_data');
          this.plQuarterlyDataStandalone = {};
          this.arrangedDataStandalone = [];
          this.headerDatesStandalone = [];
          return;
        }
               
        this.plQuarterlyDataStandalone = response.extracted_data;
        const rowMap = new Map<string, any>();
        this.headerDatesStandalone = []; // Reset headers

        // Extract date keys as headers (e.g., "30 September 2025", "30 June 2025")
        this.headerDatesStandalone = Object.keys(this.plQuarterlyDataStandalone);
        
        // console.log('Date Headers:', this.headerDatesStandalone);

        // Process each allowed item across all dates
        this.allowedItems.forEach(itemLabel => {
          // Skip the second PAT item - we'll handle it in the fallback logic
          if (itemLabel === 'Profit after tax for the period/year from continuing operations') {
            return; // Skip this, will be handled as fallback for PAT
          }
          // Skip the other EPS items - we'll handle them in the fallback logic
          // Keep the first EPS item to process, skip the other two and the short one
          if (itemLabel === 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
              itemLabel === 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
              itemLabel === 'Earnings per equity share') {
            return; // Skip these, will be handled as fallback for EPS
          }
          
          // Use the display label (e.g., "PBIDT", "PAT") instead of the full item label
          const displayLabel = this.getAllowedItemLabel(itemLabel);
          const rowData: any = { label: displayLabel };
          
          // Special handling for PAT: check for first item, if not found, use second item
          if (displayLabel === 'PAT') {
            const patItem1 = 'Profit for the period / year';
            const patItem2 = 'Profit after tax for the period/year from continuing operations';
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              // Try first PAT item
              if (dateData && dateData[patItem1] !== undefined && dateData[patItem1] !== null) {
                rowData[dateKey] = dateData[patItem1];
              } 
              // Fallback to second PAT item
              else if (dateData && dateData[patItem2] !== undefined && dateData[patItem2] !== null) {
                rowData[dateKey] = dateData[patItem2];
              } 
              else {
                rowData[dateKey] = '-';
              }
            });
          } 
          else  if (displayLabel === 'PBT') {
            const patItem1 = 'Profit before tax';
            const patItem2 = 'Profit before tax from continuing operations';
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              // Try first PAT item
              if (dateData && dateData[patItem1] !== undefined && dateData[patItem1] !== null) {
                rowData[dateKey] = dateData[patItem1];
              } 
              // Fallback to second PAT item
              else if (dateData && dateData[patItem2] !== undefined && dateData[patItem2] !== null) {
                rowData[dateKey] = dateData[patItem2];
              } 
              else {
                rowData[dateKey] = '-';
              }
            });
          }
          else  if (displayLabel === 'Current Tax') {
            const patItem1 = '"Tax expense:↵Current tax"';
            const patItem2 = '"Tax expense:↵a) Current tax"';
            const patItem3 = 'Current tax';
            const patItem4 = 'a) Current tax';
            
            // Normalize the item names for matching
            const normalizedPat1 = this.normalizeItemName(patItem1);
            const normalizedPat2 = this.normalizeItemName(patItem2);
            const normalizedPat3 = this.normalizeItemName(patItem3);
            const normalizedPat4 = this.normalizeItemName(patItem4);
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              let foundValue = null;
              
              // Iterate through all keys to find matching Current Tax items
              if (dateData) {
                Object.keys(dateData).forEach(key => {
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Try first item
                  if (!foundValue && normalizedField === normalizedPat1) {
                    foundValue = dateData[key];
                  }
                  // Try second item
                  else if (!foundValue && normalizedField === normalizedPat2) {
                    foundValue = dateData[key];
                  }
                  // Try third item
                  else if (!foundValue && normalizedField === normalizedPat3) {
                    foundValue = dateData[key];
                  }
                  // Fallback to fourth item
                  else if (!foundValue && normalizedField === normalizedPat4) {
                    foundValue = dateData[key];
                  }
                });
              }
              
              rowData[dateKey] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
            });
          }
           else  if (displayLabel === 'Deferred Tax') {
             const patItem1 = 'b) Deferred tax charge/ (credit)';
             const patItem2 = 'b) Deferred tax charge/ (benefit)';
             const patItem3 = 'Deferred tax charge/ (credit)';
             const patItem4 = 'Deferred tax';

             this.headerDatesStandalone.forEach(dateKey => {
               const dateData = this.plQuarterlyDataStandalone[dateKey];
               // Try first item
               if (dateData && dateData[patItem1] !== undefined && dateData[patItem1] !== null) {
                 rowData[dateKey] = dateData[patItem1];
               } 
               // Fallback to second item
               else if (dateData && dateData[patItem2] !== undefined && dateData[patItem2] !== null) {
                 rowData[dateKey] = dateData[patItem2];
               } 
               // Fallback to third item
               else if (dateData && dateData[patItem3] !== undefined && dateData[patItem3] !== null) {
                 rowData[dateKey] = dateData[patItem3];
               } 
               else if (dateData && dateData[patItem4] !== undefined && dateData[patItem4] !== null) {
                rowData[dateKey] = dateData[patItem4];
              } 
               else {
                 rowData[dateKey] = '-';
               }
             });
           }
          else if (displayLabel === 'PBIDT') {
            const patItem1 = 'Profit before tax, finance cost, depreciation and amortization expenses';
            const patItem2 = 'Profit before tax, finance cost, depreciation and amortization expenses from continuing operations';
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              // Try first PAT item
              if (dateData && dateData[patItem1] !== undefined && dateData[patItem1] !== null) {
                rowData[dateKey] = dateData[patItem1];
              } 
              // Fallback to second PAT item
              else if (dateData && dateData[patItem2] !== undefined && dateData[patItem2] !== null) {
                rowData[dateKey] = dateData[patItem2];
              } 
              else {
                rowData[dateKey] = '-';
              }
            });
          } 
          else if (displayLabel === 'Total Expenses') {
            const patItem1 = 'Total Expenses';
            const patItem2 = 'Total expenses';
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              // Try first PAT item
              if (dateData && dateData[patItem1] !== undefined && dateData[patItem1] !== null) {
                rowData[dateKey] = dateData[patItem1];
              } 
              // Fallback to second PAT item
              else if (dateData && dateData[patItem2] !== undefined && dateData[patItem2] !== null) {
                rowData[dateKey] = dateData[patItem2];
              } 
              else {
                rowData[dateKey] = '-';
              }
            });
          }
          else if (displayLabel === 'EPS') {
            const epsItem1 = 'Earnings per equity share for continuing and discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem2 = 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem3 = 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem4 = 'Earnings per equity share';
            const epsItem5 = '"Earnings per equity share↵Basic and Diluted (in ₹) (Face value of ₹ 10 each)"';
            const epsItem6 = '"Earnings per equity share for continuing and discontinued operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            const epsItem7 = '"Earnings per equity share for continuing operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            const epsItem8 = '"Earnings per equity share for discontinued operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              let totalEps = 0;
              let hasValue = false;
              
              // Helper function to parse and add EPS value
              const addEpsValue = (value: any) => {
                if (value !== undefined && value !== null && value !== '-') {
                  // Remove commas and parse as number
                  const numValue = parseFloat(String(value).replace(/,/g, ''));
                  if (!isNaN(numValue)) {
                    totalEps += numValue;
                    hasValue = true;
                  }
                }
              };
              
              // Normalize all EPS item names for matching
              const normalizedEps1 = this.normalizeItemName(epsItem1);
              const normalizedEps2 = this.normalizeItemName(epsItem2);
              const normalizedEps3 = this.normalizeItemName(epsItem3);
              const normalizedEps4 = this.normalizeItemName(epsItem4);
              const normalizedEps5 = this.normalizeItemName(epsItem5);
              const normalizedEps6 = this.normalizeItemName(epsItem6);
              const normalizedEps7 = this.normalizeItemName(epsItem7);
              const normalizedEps8 = this.normalizeItemName(epsItem8);
              
              // Sum all available EPS values by iterating through all keys
              if (dateData) {
                // Iterate through all keys to find matching EPS items
                Object.keys(dateData).forEach(key => {
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Check if this key matches any of the main EPS items (1, 2, 3, 6, 7, 8)
                  if (normalizedField === normalizedEps1 || 
                      normalizedField === normalizedEps2 || 
                      normalizedField === normalizedEps3 ||
                      normalizedField === normalizedEps6 ||
                      normalizedField === normalizedEps7 ||
                      normalizedField === normalizedEps8) {
                    const value = dateData[key];
                    addEpsValue(value);
                    // console.log(`EPS Found - Key: "${key}", Normalized: "${normalizedField}", Value: ${value}, Total so far: ${totalEps}`);
                  }
                  // Only check fallback items (4, 5) if no main items found yet
                  else if (!hasValue && (normalizedField === normalizedEps4 || normalizedField === normalizedEps5)) {
                    const value = dateData[key];
                    addEpsValue(value);
                    // console.log(`EPS Fallback Found - Key: "${key}", Normalized: "${normalizedField}", Value: ${value}`);
                  }
                });
                
                // console.log(`EPS Calculation for ${dateKey} - Final Total: ${totalEps}, HasValue: ${hasValue}`);
              }
              
              // Display the sum if we have values, otherwise show '-'
              if (hasValue) {
                // Format the number with 2 decimal places
                rowData[dateKey] = totalEps.toFixed(2);
              } else {
                rowData[dateKey] = '-';
              }
            });
          } 
          else {
            // For other items, use the itemLabel directly
            this.headerDatesStandalone.forEach(dateKey => {
              const dateData = this.plQuarterlyDataStandalone[dateKey];
              if (dateData && dateData[itemLabel] !== undefined && dateData[itemLabel] !== null) {
                rowData[dateKey] = dateData[itemLabel];
              } else {
                rowData[dateKey] = '-';
              }
            });
          }
          
          rowMap.set(displayLabel, rowData);
        });
        
        // Convert map to array for display
        this.arrangedDataStandalone = Array.from(rowMap.values());
        
        // console.log('Arranged Standalone Data:', this.arrangedDataStandalone);
        // console.log('Arranged plQuarterlyDataStandalone Data:', this.plQuarterlyDataStandalone);
        // console.log('Header Dates:', this.headerDatesStandalone);
        
        // Initialize charts after data is loaded
        if (this.activeTypeTab === 'standalone' && this.activePLTab === 'quarterly') {
          setTimeout(() => {
            this.initializeQuarterlyPLCharts('standalone');
          }, 500);
        }
       
   }, error => {
    // console.error('Error fetching financial extract data:', error);
    this.plQuarterlyDataStandalone = {};
    this.arrangedDataStandalone = [];
    this.headerDatesStandalone = [];
   } )
  }

  // Helper function to normalize item names for matching (removes quotes, normalizes case and spaces)
  normalizeItemName(name: string): string {
    if (!name) return '';
    return name
      .replace(/'/g, '') // Remove single quotes
      .replace(/"/g, '') // Remove double quotes
      .replace(/↵/g, ' ') // Replace line break character with space
      .replace(/\s+/g, ' ') // Normalize multiple spaces to single space
      .replace(/\)\s*/g, ') ') // Ensure space after closing parenthesis
      .replace(/\s*\(/g, ' (') // Ensure space before opening parenthesis
      .replace(/\s+/g, ' ') // Normalize multiple spaces again after above replacements
      .trim()
      .toLowerCase();
  }

  // Helper function to check if a key matches any allowed item (case-insensitive, quote-insensitive)
  isAllowedItem(key: string): boolean {
    const normalizedField = this.normalizeItemName(key);
    return this.allowedItems.some(item => this.normalizeItemName(item) === normalizedField);
  }

  // Helper function to get the correct label from allowedItems for a given key
  getAllowedItemLabel(key: string): string {
    const normalizedField = this.normalizeItemName(key);
    const matchedItem = this.allowedItems.find(item => this.normalizeItemName(item) === normalizedField);
    
    // Map specific labels to display names
    if (matchedItem) {
      // Display "PBIDT" for "Profit before tax, finance cost, depreciation and amortization expenses"
      if (matchedItem === 'Profit before tax, finance cost, depreciation and amortization expenses' || matchedItem === 'Profit before tax, finance cost, depreciation and amortization expenses from continuing operations') {
        return 'PBIDT';
      }
      if (matchedItem === 'Profit before tax') {
        return 'PBT';
      }
      // Display "PAT" for "Profit for the period / year"
      if (matchedItem === 'a) Current tax') {
        return 'Current Tax';
      }
      if (matchedItem === 'b) Deferred tax charge/ (credit)') {
        return 'Deferred Tax';
      }
      if (matchedItem === 'Profit for the period / year' || matchedItem === 'Profit after tax for the period/year from continuing operations') {
        return 'PAT';
      }
      if (matchedItem === 'Paid up equity share capital') {
        return 'Equity';
      }
       if (matchedItem === 'Earnings per equity share' || 
           matchedItem === 'Earnings per equity share for continuing and discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
           matchedItem === 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
           matchedItem === 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)') {
         return 'EPS';
       }
      return matchedItem;
    }
    
    // Return the key as-is if not found
    return key;
  }

  getPLQuarterlyConsolidated(symbol){
    this.chatbotService.getPLQuarterlyConsolidated(symbol).subscribe(
      (response: any) => {
        this.plQuarterlyDataConsolidated = response && response.tableData ? response.tableData : [];
        // console.log('PL Quarterly Consolidated Response:', this.plQuarterlyDataConsolidated);

        const rowMap = new Map<string, any>();

        // First, collect all date headers
        if (this.plQuarterlyDataConsolidated && Array.isArray(this.plQuarterlyDataConsolidated)) {
          this.plQuarterlyDataConsolidated.forEach(item => {
            if (item && item.date) {
              const header = item.date;
              if (!this.dateHeadersConsolidated.includes(header)) {
                this.dateHeadersConsolidated.push(header);
              }
            }
          });
        }

        // Process each allowed item across all dates (similar to standalone approach)
        this.allowedItems.forEach(itemLabel => {
          // Skip the second PAT item - we'll handle it in the fallback logic
          if (itemLabel === 'Profit after tax for the period year from continuing operations') {
            return; // Skip this, will be handled as fallback for PAT
          }
          // Skip the other EPS items - we'll handle them in the fallback logic
          // Keep the first EPS item to process, skip the other two and the short one
          if (itemLabel === 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
              itemLabel === 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)' ||
              itemLabel === 'Earnings per equity share') {
            return; // Skip these, will be handled as fallback for EPS
          }
          
          // Use the display label (e.g., "PBIDT", "PAT") instead of the full item label
          const displayLabel = this.getAllowedItemLabel(itemLabel);
          const rowData: any = { label: displayLabel };
          
          // Special handling for PAT: check for first item, if not found, use second item
          if (displayLabel === 'PAT') {
            const patItem1 = 'Profit after tax for the period/year from continuing operations';
            const patItem2 = 'Profit after tax for the period year from continuing operations';
            
            this.dateHeadersConsolidated.forEach(header => {
              // Find the item for this date
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              
              if (dateItem) {
                // Try to find first PAT item in this date's data (with normalization)
                let foundValue = null;
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  const normalizedPat1 = this.normalizeItemName(patItem1);
                  const normalizedPat2 = this.normalizeItemName(patItem2);
                  
                  // Try first PAT item
                  if (normalizedField === normalizedPat1) {
                    foundValue = dateItem[key];
                  }
                  // Fallback to second PAT item if first not found
                  else if (!foundValue && normalizedField === normalizedPat2) {
                    foundValue = dateItem[key];
                  }
                });
                
                rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
              } else {
                rowData[header] = '-';
              }
            });
          }
          else if (displayLabel === 'EPS') {
            const epsItem1 = 'Earnings per equity share for continuing and discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem2 = 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem3 = 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem4 = 'Earnings per equity share';
            const epsItem5 = '"Earnings per equity share↵Basic and Diluted (in ₹) (Face value of ₹ 10 each)"';
            const epsItem6 = '"Earnings per equity share for continuing and discontinued operations↵Basic and Diluted (in↵) (Face value of↵10 each)"';
            const epsItem7 = '"Earnings per equity share for continuing operations↵Basic and Diluted (in↵) (Face value of↵10 each)"';
            const epsItem8 = '"Earnings per equity share for discontinued operations↵Basic and Diluted (in↵) (Face value of↵10 each)"';
            
            this.dateHeadersConsolidated.forEach(header => {
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              
              if (dateItem) {
                let totalEps = 0;
                let hasValue = false;
                
                // Helper function to parse and add EPS value
                const addEpsValue = (value: any) => {
                  if (value !== undefined && value !== null && value !== '-') {
                    // Remove commas and parse as number
                    const numValue = parseFloat(String(value).replace(/,/g, ''));
                    if (!isNaN(numValue)) {
                      totalEps += numValue;
                      hasValue = true;
                    }
                  }
                };
                
                // Find and sum all available EPS values (with normalization)
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  const normalizedEps1 = this.normalizeItemName(epsItem1);
                  const normalizedEps2 = this.normalizeItemName(epsItem2);
                  const normalizedEps3 = this.normalizeItemName(epsItem3);
                  const normalizedEps4 = this.normalizeItemName(epsItem4);
                  const normalizedEps5 = this.normalizeItemName(epsItem5);
                  const normalizedEps6 = this.normalizeItemName(epsItem6);
                  const normalizedEps7 = this.normalizeItemName(epsItem7);
                  const normalizedEps8 = this.normalizeItemName(epsItem8);
                  
                  // Sum all matching EPS items (epsItem1, 2, 3, 6, 7, 8)
                  if (normalizedField === normalizedEps1 || 
                      normalizedField === normalizedEps2 || 
                      normalizedField === normalizedEps3 ||
                      normalizedField === normalizedEps6 ||
                      normalizedField === normalizedEps7 ||
                      normalizedField === normalizedEps8) {
                    addEpsValue(dateItem[key]);
                  }
                  // Only add epsItem4 and epsItem5 if none of the above exist
                  else if (!hasValue && (normalizedField === normalizedEps4 || normalizedField === normalizedEps5)) {
                    addEpsValue(dateItem[key]);
                  }
                });
                
                // Display the sum if we have values, otherwise show '-'
                if (hasValue) {
                  // Format the number with 2 decimal places
                  rowData[header] = totalEps.toFixed(2);
                } else {
                  rowData[header] = '-';
                }
              } else {
                rowData[header] = '-';
              }
            });
          }
          else if (displayLabel === 'Current Tax') {
            const patItem1 = '"Tax expense:↵Current tax"';
            const patItem2 = 'Current tax';
            const patItem3 = 'a) Current tax';
            
            // Normalize the item names for matching
            const normalizedPat1 = this.normalizeItemName(patItem1);
            const normalizedPat2 = this.normalizeItemName(patItem2);
            const normalizedPat3 = this.normalizeItemName(patItem3);
            
            this.dateHeadersConsolidated.forEach(header => {
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              let foundValue = null;
              
              // Iterate through all keys to find matching Current Tax items
              if (dateItem) {
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Try first item
                  if (!foundValue && normalizedField === normalizedPat1) {
                    foundValue = dateItem[key];
                  }
                  // Try second item
                  else if (!foundValue && normalizedField === normalizedPat2) {
                    foundValue = dateItem[key];
                  }
                  // Fallback to third item
                  else if (!foundValue && normalizedField === normalizedPat3) {
                    foundValue = dateItem[key];
                  }
                });
              }
              
              rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
            });
          }
          else  if (displayLabel === 'PBT') {
            const patItem1 = 'Profit before tax';
            const patItem2 = 'Profit before tax from continuing operations';
            
            // Normalize the item names for matching
            const normalizedPat1 = this.normalizeItemName(patItem1);
            const normalizedPat2 = this.normalizeItemName(patItem2);
            
            this.dateHeadersConsolidated.forEach(header => {
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              let foundValue = null;
              
              // Iterate through all keys to find matching PBT items
              if (dateItem) {
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Try first item
                  if (!foundValue && normalizedField === normalizedPat1) {
                    foundValue = dateItem[key];
                  }
                  // Fallback to second item
                  else if (!foundValue && normalizedField === normalizedPat2) {
                    foundValue = dateItem[key];
                  }
                });
              }
              
              rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
            });
          }
           else if (displayLabel === 'PBIDT') {
             const patItem1 = 'Profit before tax, finance cost, depreciation and amortization expenses';
             const patItem2 = 'Profit before tax, finance cost, depreciation and amortization expenses from continuing operations';
             
             // Normalize the item names for matching
             const normalizedPat1 = this.normalizeItemName(patItem1);
             const normalizedPat2 = this.normalizeItemName(patItem2);
             
             this.dateHeadersConsolidated.forEach(header => {
               if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                 rowData[header] = '-';
                 return;
               }
               const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
               let foundValue = null;
               
               // Iterate through all keys to find matching PBIDT items
               if (dateItem) {
                 Object.keys(dateItem).forEach(key => {
                   if (key === 'date') return;
                   const normalizedField = this.normalizeItemName(key);
                   
                   // Try first item
                   if (!foundValue && normalizedField === normalizedPat1) {
                     foundValue = dateItem[key];
                   }
                   // Fallback to second item
                   else if (!foundValue && normalizedField === normalizedPat2) {
                     foundValue = dateItem[key];
                   }
                 });
               }
               
               rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
             });
           }
          else if (displayLabel === 'EPS') {
            const epsItem1 = 'Earnings per equity share for continuing and discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem2 = 'Earnings per equity share for continuing operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem3 = 'Earnings per equity share for discontinued operations Basic and Diluted (in ₹) (Face value of ₹ 10 each)';
            const epsItem4 = 'Earnings per equity share';
            const epsItem5 = '"Earnings per equity share↵Basic and Diluted (in ₹) (Face value of ₹ 10 each)"';
            const epsItem6 = '"Earnings per equity share for continuing and discontinued operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            const epsItem7 = '"Earnings per equity share for continuing operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            const epsItem8 = '"Earnings per equity share for discontinued operations↵Basic and Diluted (in↵) (Face value of ₹ 10 each)"';
            
            this.dateHeadersConsolidated.forEach(dateKey => {
              // Skip if plQuarterlyDataConsolidated is not an array
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[dateKey] = '-';
                return;
              }
              const dateData = this.plQuarterlyDataConsolidated[dateKey];
              let totalEps = 0;
              let hasValue = false;
              
              // Helper function to parse and add EPS value
              const addEpsValue = (value: any) => {
                if (value !== undefined && value !== null && value !== '-') {
                  // Remove commas and parse as number
                  const numValue = parseFloat(String(value).replace(/,/g, ''));
                  if (!isNaN(numValue)) {
                    totalEps += numValue;
                    hasValue = true;
                  }
                }
              };
              
              // Normalize all EPS item names for matching
              const normalizedEps1 = this.normalizeItemName(epsItem1);
              const normalizedEps2 = this.normalizeItemName(epsItem2);
              const normalizedEps3 = this.normalizeItemName(epsItem3);
              const normalizedEps4 = this.normalizeItemName(epsItem4);
              const normalizedEps5 = this.normalizeItemName(epsItem5);
              const normalizedEps6 = this.normalizeItemName(epsItem6);
              const normalizedEps7 = this.normalizeItemName(epsItem7);
              const normalizedEps8 = this.normalizeItemName(epsItem8);
              
              // Sum all available EPS values by iterating through all keys
              if (dateData) {
                // Iterate through all keys to find matching EPS items
                Object.keys(dateData).forEach(key => {
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Check if this key matches any of the main EPS items (1, 2, 3, 6, 7, 8)
                  if (normalizedField === normalizedEps1 || 
                      normalizedField === normalizedEps2 || 
                      normalizedField === normalizedEps3 ||
                      normalizedField === normalizedEps6 ||
                      normalizedField === normalizedEps7 ||
                      normalizedField === normalizedEps8) {
                    const value = dateData[key];
                    addEpsValue(value);
                    // console.log(`EPS Found - Key: "${key}", Normalized: "${normalizedField}", Value: ${value}, Total so far: ${totalEps}`);
                  }
                  // Only check fallback items (4, 5) if no main items found yet
                  else if (!hasValue && (normalizedField === normalizedEps4 || normalizedField === normalizedEps5)) {
                    const value = dateData[key];
                    addEpsValue(value);
                    // console.log(`EPS Fallback Found - Key: "${key}", Normalized: "${normalizedField}", Value: ${value}`);
                  }
                });
                
                // console.log(`EPS Calculation for ${dateKey} - Final Total: ${totalEps}, HasValue: ${hasValue}`);
              }
              
              // Display the sum if we have values, otherwise show '-'
              if (hasValue) {
                // Format the number with 2 decimal places
                rowData[dateKey] = totalEps.toFixed(2);
              } else {
                rowData[dateKey] = '-';
              }
            });
          }
          else  if (displayLabel === 'Deferred Tax') {
            const patItem1 = 'by Deferred tax (Credit)';
            const patItem2 = 'b) Deferred tax charge/ (benefit)';
            const patItem3 = 'Deferred tax charge (credit)';
            const patItem4 = 'b) Deferred tax charge/ (credit)';
            
            // Normalize the item names for matching
            const normalizedPat1 = this.normalizeItemName(patItem1);
            const normalizedPat2 = this.normalizeItemName(patItem2);
            const normalizedPat3 = this.normalizeItemName(patItem3);
            const normalizedPat4 = this.normalizeItemName(patItem4);
            
            this.dateHeadersConsolidated.forEach(header => {
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              let foundValue = null;
              
              // Iterate through all keys to find matching Deferred Tax items
              if (dateItem) {
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  
                  // Try first item
                  if (!foundValue && normalizedField === normalizedPat1) {
                    foundValue = dateItem[key];
                  }
                  // Try second item
                  else if (!foundValue && normalizedField === normalizedPat2) {
                    foundValue = dateItem[key];
                  }
                  // Try third item
                  else if (!foundValue && normalizedField === normalizedPat3) {
                    foundValue = dateItem[key];
                  }
                  // Try fourth item
                  else if (!foundValue && normalizedField === normalizedPat4) {
                    foundValue = dateItem[key];
                  }
                });
              }
              
              rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
            });
          }
          else if (displayLabel === 'Equity') {
            // Set fixed value of 3,962 for all dates in consolidated quarterly
            this.dateHeadersConsolidated.forEach(header => {
              rowData[header] = '3,962';
            });
          }
          else {
            // For other items, find the matching key in each date's data
            this.dateHeadersConsolidated.forEach(header => {
              if (!Array.isArray(this.plQuarterlyDataConsolidated)) {
                rowData[header] = '-';
                return;
              }
              const dateItem = this.plQuarterlyDataConsolidated.find(item => item && item.date === header);
              
              if (dateItem) {
                // Find the key that matches this itemLabel (with normalization)
                let foundValue = null;
                Object.keys(dateItem).forEach(key => {
                  if (key === 'date') return;
                  const normalizedField = this.normalizeItemName(key);
                  const normalizedItemLabel = this.normalizeItemName(itemLabel);
                  
                  if (normalizedField === normalizedItemLabel) {
                    foundValue = dateItem[key];
                  }
                });
                
                rowData[header] = foundValue !== null && foundValue !== undefined ? foundValue : '-';
              } else {
                rowData[header] = '-';
              }
            });
          }
          
          rowMap.set(displayLabel, rowData);
        });
        this.arrangedDataConsolidated = Array.from(rowMap.values());
        // console.log('PL Quarterly Consolidated Arranged Data:', this.arrangedDataConsolidated);
        
        // Initialize charts after data is loaded
        if (this.activeTypeTab === 'consolidated' && this.activePLTab === 'quarterly') {
          setTimeout(() => {
            this.initializeQuarterlyPLCharts('consolidated');
          }, 500);
        }
   }, error => {
    // console.error('Error fetching financial extract data:', error);
   } )
  }
  getPLAnnualStandalone(symbol) {
    if (!symbol) {
      // console.warn('Symbol not found in localStorage');
      return;
    }
    this.chatbotService.getPLAnnualStandalone(symbol).subscribe(
      (response: any) => {
        if (response && response.tableData) {
          const tableData = response.tableData;
          
          if (Array.isArray(tableData) && tableData.length > 0 && tableData[0].label) {
            // Extract unique year headers from all rows
            const yearSet = new Set<string>();
            tableData.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                // Include all keys except 'label' (can be number or string year format)
                if (key !== 'label' && (typeof row[key] === 'number' || typeof row[key] === 'string')) {
                  yearSet.add(key);
                }
              });
            });
            
            // Sort years in descending order (newest first)
            this.plAnnualStandaloneHeaders = Array.from(yearSet).sort((a, b) => {
              const aParts = a.split('-');
              const bParts = b.split('-');
              const aStart = aParts[0].length === 2 ? parseInt('20' + aParts[0]) : parseInt(aParts[0]);
              const bStart = bParts[0].length === 2 ? parseInt('20' + bParts[0]) : parseInt(bParts[0]);
              return bStart - aStart;
            });
            
            this.plAnnualDataStandalone = tableData;
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataStandalone, this.plAnnualStandaloneHeaders);
            
            // Initialize charts after data is loaded
            if (this.activeTypeTab === 'standalone' && this.activePLTab === 'annual') {
              setTimeout(() => {
                this.initializeAnnualPLCharts('standalone');
              }, 500);
            }
          } else if (Array.isArray(tableData) && tableData.length > 0 && Array.isArray(tableData[0])) {
            // Legacy format: array of arrays (first row is headers)
            // First element is usually empty or "Item", skip it and take rest as year headers
            const headerRow = tableData[0] || [];
            this.plAnnualStandaloneHeaders = headerRow.slice(1) || []; // Skip first column (label column)
            this.plAnnualDataStandalone = tableData.slice(1) || [];
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataStandalone, this.plAnnualStandaloneHeaders);
          } else {
            this.plAnnualDataStandalone = tableData;
            this.plAnnualStandaloneHeaders = [];
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataStandalone, this.plAnnualStandaloneHeaders);
          }
        } else {
          this.plAnnualDataStandalone = [];
          this.plAnnualStandaloneHeaders = [];
        }
      },
      error => {
        // console.error('Error fetching PL annual standalone data:', error);
        this.plAnnualDataStandalone = [];
        this.plAnnualStandaloneHeaders = [];
      }
    );
  }
  getPLAnnualConsolidated(symbol) {
    if (!symbol) {
      // console.warn('Symbol not found in localStorage');
      return;
    }
    this.chatbotService.getPLAnnualConsolidated(symbol).subscribe(
      (response: any) => {
        if (response && response.tableData) {
          const tableData = response.tableData;
          
          if (Array.isArray(tableData) && tableData.length > 0 && tableData[0].label) {
            const yearSet = new Set<string>();
            tableData.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                // Include all keys except 'label' (can be number or string year format)
                if (key !== 'label' && (typeof row[key] === 'number' || typeof row[key] === 'string')) {
                  yearSet.add(key);
                }
              });
            });
            
            // Sort years in descending order (newest first)
            this.plAnnualConsolidatedHeaders = Array.from(yearSet).sort((a, b) => {
              const aParts = a.split('-');
              const bParts = b.split('-');
              const aStart = aParts[0].length === 2 ? parseInt('20' + aParts[0]) : parseInt(aParts[0]);
              const bStart = bParts[0].length === 2 ? parseInt('20' + bParts[0]) : parseInt(bParts[0]);
              return bStart - aStart;
            });
            
            this.plAnnualDataConsolidated = tableData;
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataConsolidated, this.plAnnualConsolidatedHeaders);
            
            // Initialize charts after data is loaded
            if (this.activeTypeTab === 'consolidated' && this.activePLTab === 'annual') {
              setTimeout(() => {
                this.initializeAnnualPLCharts('consolidated');
              }, 500);
            }
          } else if (Array.isArray(tableData) && tableData.length > 0 && Array.isArray(tableData[0])) {
            const headerRow = tableData[0] || [];
            this.plAnnualConsolidatedHeaders = headerRow.slice(1) || []; // Skip first column (label column)
            this.plAnnualDataConsolidated = tableData.slice(1) || [];
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataConsolidated, this.plAnnualConsolidatedHeaders);
          } else {
            this.plAnnualDataConsolidated = tableData;
            this.plAnnualConsolidatedHeaders = [];
            // Set Equity to 3,962 for all years
            this.setEquityValue(this.plAnnualDataConsolidated, this.plAnnualConsolidatedHeaders);
          }
        } else {
          this.plAnnualDataConsolidated = [];
          this.plAnnualConsolidatedHeaders = [];
        }
      },
      error => {
        // console.error('Error fetching PL annual consolidated data:', error);
        this.plAnnualDataConsolidated = [];
        this.plAnnualConsolidatedHeaders = [];
      }
    );
  }
  loadPLAnnual() {
    this.isLoadingPLAnnual = true;
    // Data is already loaded in ngOnInit, just update loading state
    setTimeout(() => {
      this.isLoadingPLAnnual = false;
    }, 100);
  }

  loadBS() {
    this.isLoadingBS = true;
    if (this.activeTypeTab === 'standalone') {
      this.isLoadingBSStandalone = true;
      // Data is already loaded in ngOnInit, just update loading state
      setTimeout(() => {
        this.isLoadingBSStandalone = false;
        this.isLoadingBS = false;
      }, 100);
    } else {
      this.isLoadingBSConsolidated = true;
      // Data is already loaded in ngOnInit, just update loading state
      setTimeout(() => {
        this.isLoadingBSConsolidated = false;
        this.isLoadingBS = false;
      }, 100);
    }
  }

  displayValue(val: any, label?: string): any {
    if (val === null || val === undefined || val === '') return '-';
    
    // Check if this is an EPS value - preserve decimal point
    const isEPS = label && (
      label === 'EPS' || 
      label === 'Earnings per equity share' ||
      label.includes('Earnings per equity share')
    );
    
    // If value is already a string with commas, return as is (already formatted)
    if (typeof val === 'string' && val.includes(',')) {
      return val;
    }
    
    // Convert to number for formatting - handle both number and numeric string
    let numVal: number | null = null;
    if (typeof val === 'number') {
      numVal = val;
    } else if (typeof val === 'string') {
      // Remove any existing commas and try to parse as number
      const cleanedVal = val.trim().replace(/,/g, '');
      if (cleanedVal !== '' && !isNaN(Number(cleanedVal))) {
        numVal = parseFloat(cleanedVal);
      }
    }
    
    // If we have a valid number, format it
    if (numVal !== null && !isNaN(numVal)) {
      // For EPS values, preserve decimal formatting
      if (isEPS) {
        return numVal.toFixed(2);
      }
      // Format number with thousands separators
      const formatted = numVal.toLocaleString('en-IN');
      // For balance sheet standalone, replace dots with commas
      // For P&L views (quarterly/annual), always use commas
      if (this.activeTypeTab === 'standalone' || this.activeMainTab === 'profitAndLoss') {
        return formatted.replace(/\./g, ',');
      }
      return formatted;
    }
    if (typeof val === 'object') {
      try {
        return JSON.stringify(val);
      } catch {
        return '-';
      }
    }
    const str = String(val).trim();
    
    // For EPS values, preserve the decimal point
    if (isEPS) {
      // If it's a valid number with decimal, return as is
      const num = parseFloat(str.replace(/,/g, ''));
      if (!isNaN(num)) {
        return num.toFixed(2);
      }
      return str;
    }
    
    if (this.activeTypeTab === 'standalone') {
      if (str.includes('.') && !str.includes(',')) {
        const num = parseFloat(str.replace(/\./g, ''));
        if (!isNaN(num)) {
          return num.toLocaleString('en-IN');
        }
      }
      return str.replace(/\./g, ',');
    }
    return str;
  }

  formatYearHeader(yearKey: string): string {
    if (!yearKey) return '';
    // Convert to "2025-2024" format (higher year first, then lower year)
    if (yearKey.includes('-')) {
      const parts = yearKey.split('-');
      if (parts.length === 2) {
        let year1: number;
        let year2: number;
        const part1 = parts[0].trim();
        const part2 = parts[1].trim();
        
        // Handle 4-digit years
        if (part1.length === 4 && part2.length === 4) {
          year1 = parseInt(part1);
          year2 = parseInt(part2);
        } 
        // Handle 2-digit years
        else if (part1.length === 2 && part2.length === 2) {
          const num1 = parseInt(part1);
          const num2 = parseInt(part2);
          
          // Convert to 4-digit years (assuming 2000s)
          year1 = 2000 + num1;
          year2 = 2000 + num2;
        } else {
          return yearKey; // Invalid format, return as is
        }
        
        // Format as higher_year-lower_year (e.g., 2025-2024)
        if (year1 > year2) {
          return `${year1}-${year2}`;
        } else if (year2 > year1) {
          return `${year2}-${year1}`;
        } else {
          return `${year1}-${year2}`;
        }
      }
    }
    return yearKey;
  }

  getRowClass(label: string): string {
    if (!label) return '';
    const upperLabel = label.toUpperCase();
    
    // Main section headings: ASSETS, EQUITIES AND LIABILITIES
    if (upperLabel === 'ASSETS' || upperLabel === 'EQUITIES AND LIABILITIES') {
      return 'bs-main-heading';
    }
    
    // Total rows: TOTAL ASSETS, TOTAL EQUITIES AND LIABILITIES
    if (upperLabel === 'TOTAL ASSETS' || upperLabel === 'TOTAL EQUITIES AND LIABILITIES') {
      return 'bs-total-row';
    }
    
    // Sub-categories (everything else)
    return 'bs-sub-category';
  }

  getRowPadding(label: string): string {
    if (!label) return '10px';
    const upperLabel = label.toUpperCase();
    
    // Main section headings: no padding
    if (upperLabel === 'ASSETS' || upperLabel === 'EQUITIES AND LIABILITIES') {
      return '10px';
    }
    
    // Total rows: no padding (aligned with main headings)
    if (upperLabel === 'TOTAL ASSETS' || upperLabel === 'TOTAL EQUITIES AND LIABILITIES') {
      return '10px';
    }
    
    // Sub-categories: indent
    return '30px';
  }

  // Get quarterly label from row data - displays exact label from service
  getQuarterlyLabel(row: any): string {
    if (!row) return '-';
    
    // If row has label property, use it directly (exact from service)
    if (row.label !== undefined) {
      return row.label || '-';
    }
    
    // If row is an array, first element is the label
    if (Array.isArray(row) && row.length > 0) {
      return row[0] || '-';
    }
    
    // Fallback
    return '-';
  }

  // Check if a section heading should be inserted before current row
  shouldInsertSectionHeading(currentLabel: string, previousLabel: string, index: number): boolean {
    if (!currentLabel) return false;
    const upperCurrent = currentLabel.toUpperCase();
    
    // First row - check if it's an asset item
    if (index === 0) {
      if (upperCurrent.includes('NON-CURRENT ASSETS') || upperCurrent.includes('CURRENT ASSETS') || 
          upperCurrent === 'TOTAL ASSETS') {
        return true; // Insert ASSETS heading
      }
    }
    
    if (!previousLabel) return false;
    const upperPrevious = previousLabel.toUpperCase();
    
    // Insert ASSETS heading before first asset item (if previous was not an asset)
    if (upperCurrent.includes('ASSETS') && !upperCurrent.includes('EQUITIES')) {
      // Check if previous item was not an asset-related item
      if (!upperPrevious.includes('ASSETS') || upperPrevious === 'TOTAL ASSETS') {
        return true;
      }
    }
    
    // Insert EQUITIES AND LIABILITIES heading before first equity/liability item
    if (upperCurrent.includes('SHARE') || upperCurrent.includes('RESERVES') || 
        (upperCurrent.includes('LIABILITIES') && !upperCurrent.includes('TOTAL ASSETS'))) {
      // Check if previous item was an asset (not equity/liability)
      if (upperPrevious.includes('ASSETS') || upperPrevious === 'TOTAL ASSETS') {
        return true;
      }
    }
    
    return false;
  }

  // Get section heading to insert before current row
  getSectionHeading(label: string, index: number): string {
    if (!label) return '';
    const upperLabel = label.toUpperCase();
    
    // First row - determine section based on label
    if (index === 0) {
      if (upperLabel.includes('ASSETS') && !upperLabel.includes('EQUITIES')) {
        return 'ASSETS';
      }
      if (upperLabel.includes('SHARE') || upperLabel.includes('RESERVES') || upperLabel.includes('LIABILITIES')) {
        return 'EQUITIES AND LIABILITIES';
      }
    }
    
    // Check if this is an asset item
    if (upperLabel.includes('ASSETS') && !upperLabel.includes('EQUITIES')) {
      return 'ASSETS';
    }
    
    // Check if this is an equity/liability item
    if (upperLabel.includes('SHARE') || upperLabel.includes('RESERVES') || 
        (upperLabel.includes('LIABILITIES') && !upperLabel.includes('TOTAL ASSETS'))) {
      return 'EQUITIES AND LIABILITIES';
    }
    
    return '';
  }

  closeModal() {
    // Close the hosting modal if present; otherwise navigate back
    const modalEl = $('#FinancialsModal');
    if (modalEl && modalEl.length) {
      modalEl.modal('hide');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    } else {
      window.history.back();
    }
  }


  getBalanceSheetStandalone(symbol) {
    this.isLoadingBSStandalone = true;
   
    if (!symbol) {
      // console.warn('Symbol not found in localStorage');
      this.isLoadingBSStandalone = false;
      return;
    }
    this.chatbotService.getBalanceSheetStandalone(symbol).subscribe(
      (response: any) => {
        // console.log("Full response:", response);
        // console.log("Response keys:", response ? Object.keys(response) : 'null');
        
        // Try different possible response structures
        let tableData = null;
        if (response) {
          tableData = response.tableData || response.data || response.result || response;
        }
                
        if (tableData) {
          // Check if it's an array of objects with label and year keys
          if (Array.isArray(tableData) && tableData.length > 0 && tableData[0].label) {
            
            // Extract unique year headers from all rows
            // Accept any key that's not 'label' - be more permissive
            const yearSet = new Set<string>();
            tableData.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                if (key !== 'label' && key !== '_id' && key !== 'id') {
                  // Accept any key that's not a reserved field
                  // This includes year strings like "2024-2025", "20-21", numeric strings, etc.
                  yearSet.add(key);
                }
              });
            });
            
            if (tableData[0]) {
            }
            
            // Sort years in descending order (newest first) - e.g., "2024-2025", "2023-2024", etc.
            // If no year-like format detected, just use the keys as-is
            this.balanceSheetStandaloneHeaders = Array.from(yearSet).sort((a, b) => {
              try {
                // Try to parse as year range (e.g., "2024-2025" or "20-21")
                const aParts = a.split('-');
                const bParts = b.split('-');
                if (aParts.length === 2 && bParts.length === 2) {
                  const aStart = aParts[0].length === 2 ? parseInt('20' + aParts[0]) : parseInt(aParts[0]);
                  const bStart = bParts[0].length === 2 ? parseInt('20' + bParts[0]) : parseInt(bParts[0]);
                  // Descending order (newest first)
                  return bStart - aStart;
                }
                // If not year format, try numeric comparison
                const aNum = parseFloat(a);
                const bNum = parseFloat(b);
                if (!isNaN(aNum) && !isNaN(bNum)) {
                  return bNum - aNum;
                }
                // Otherwise, alphabetical
                return b.localeCompare(a);
              } catch (e) {
                // If sorting fails, just return original order
                return 0;
              }
            });
            
            
            this.balanceSheetStandaloneData = tableData;
            if (this.balanceSheetStandaloneData[0] && this.balanceSheetStandaloneHeaders.length > 0) {
            }
          } else if (Array.isArray(tableData) && tableData.length > 0 && Array.isArray(tableData[0])) {
            // Legacy format: array of arrays (first row is headers)
            this.balanceSheetStandaloneHeaders = tableData[0] || [];
            this.balanceSheetStandaloneData = tableData.slice(1) || [];
          } else {
            // Handle case where tableData might be an object or other structure
            if (tableData && typeof tableData === 'object') {
              if (Array.isArray(tableData)) {
                this.balanceSheetStandaloneData = tableData;
              } else {
                // Convert object to array if needed
                this.balanceSheetStandaloneData = Object.keys(tableData).map(key => ({ label: key, ...tableData[key] }));
              }
            } else {
              this.balanceSheetStandaloneData = [];
            }
            this.balanceSheetStandaloneHeaders = [];
          }
         
          // Ensure data is always an array
          if (!Array.isArray(this.balanceSheetStandaloneData)) {
            this.balanceSheetStandaloneData = [];
          }

        } else {
          this.balanceSheetStandaloneData = [];
          this.balanceSheetStandaloneHeaders = [];
        }
        this.isLoadingBSStandalone = false;
        this.isLoadingBS = false;
      
        // Force change detection
        this.cdr.detectChanges();
        
        // Additional check after a small delay to ensure data is set
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 100);
        
        // Initialize charts after data is loaded
        if (this.activeTypeTab === 'standalone' && this.activeMainTab === 'balanceSheet') {
          setTimeout(() => {
            this.initializeBalanceSheetCharts('standalone');
          }, 500);
        }
      },
      error => {
        console.error('Error fetching balance sheet standalone data:', error);
        console.error('Error details:', error.error || error.message || error);
        this.balanceSheetStandaloneData = [];
        this.balanceSheetStandaloneHeaders = [];
        this.isLoadingBSStandalone = false;
        this.isLoadingBS = false;
        this.cdr.detectChanges();
      }
    );
  }

  getBalanceSheetConsolidated(symbol) {
    this.isLoadingBSConsolidated = true;
    if (!symbol) {
      // console.warn('Symbol not found in localStorage');
      this.isLoadingBSConsolidated = false;
      return;
    }
    this.chatbotService.getBalanceSheetConsolidated(symbol).subscribe(
      (response: any) => {
      
        // Try different possible response structures
        let tableData = null;
        if (response) {
          tableData = response.tableData || response.data || response.result || response;
        }
        
        
        if (tableData) {
          // Check if it's an array of objects with label and year keys
          if (Array.isArray(tableData) && tableData.length > 0 && tableData[0].label) {
           
            // Extract unique year headers from all rows
            // Accept any key that's not 'label' - be more permissive
            const yearSet = new Set<string>();
            tableData.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                if (key !== 'label' && key !== '_id' && key !== 'id') {
                  // Accept any key that's not a reserved field
                  // This includes year strings like "2024-2025", "20-21", numeric strings, etc.
                  yearSet.add(key);
                }
              });
            });
            
            // if (tableData[0]) {
            //   console.log("Sample row keys (Consolidated):", Object.keys(tableData[0]));
            // }
            
            // Sort years in descending order (newest first) - e.g., "2024-2025", "2023-2024", etc.
            // If no year-like format detected, just use the keys as-is
            this.balanceSheetConsolidatedHeaders = Array.from(yearSet).sort((a, b) => {
              try {
                // Try to parse as year range (e.g., "2024-2025" or "20-21")
                const aParts = a.split('-');
                const bParts = b.split('-');
                if (aParts.length === 2 && bParts.length === 2) {
                  const aStart = aParts[0].length === 2 ? parseInt('20' + aParts[0]) : parseInt(aParts[0]);
                  const bStart = bParts[0].length === 2 ? parseInt('20' + bParts[0]) : parseInt(bParts[0]);
                  // Descending order (newest first)
                  return bStart - aStart;
                }
                // If not year format, try numeric comparison
                const aNum = parseFloat(a);
                const bNum = parseFloat(b);
                if (!isNaN(aNum) && !isNaN(bNum)) {
                  return bNum - aNum;
                }
                // Otherwise, alphabetical
                return b.localeCompare(a);
              } catch (e) {
                // If sorting fails, just return original order
                return 0;
              }
            });
            
            
            this.balanceSheetConsolidatedData = tableData;
            if (this.balanceSheetConsolidatedData[0] && this.balanceSheetConsolidatedHeaders.length > 0) {
            }
          } else if (Array.isArray(tableData) && tableData.length > 0 && Array.isArray(tableData[0])) {
            // Legacy format: array of arrays (first row is headers)
            this.balanceSheetConsolidatedHeaders = tableData[0] || [];
            this.balanceSheetConsolidatedData = tableData.slice(1) || [];
          } else {
            // Handle case where tableData might be an object or other structure
            if (tableData && typeof tableData === 'object') {
              if (Array.isArray(tableData)) {
                this.balanceSheetConsolidatedData = tableData;
              } else {
                // Convert object to array if needed
                this.balanceSheetConsolidatedData = Object.keys(tableData).map(key => ({ label: key, ...tableData[key] }));
              }
            } else {
              this.balanceSheetConsolidatedData = [];
            }
            this.balanceSheetConsolidatedHeaders = [];
          }
          // Ensure data is always an array
          if (!Array.isArray(this.balanceSheetConsolidatedData)) {
            console.warn("balanceSheetConsolidatedData is not an array, converting...");
            this.balanceSheetConsolidatedData = [];
          }

        } else {
          console.warn("No tableData found in response (Consolidated):", response);
          this.balanceSheetConsolidatedData = [];
          this.balanceSheetConsolidatedHeaders = [];
        }
        this.isLoadingBSConsolidated = false;
        this.isLoadingBS = false;
       
        // Force change detection
        this.cdr.detectChanges();
        
        // Additional check after a small delay to ensure data is set
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 100);
        
        // Initialize charts after data is loaded
        if (this.activeTypeTab === 'consolidated' && this.activeMainTab === 'balanceSheet') {
          setTimeout(() => {
            this.initializeBalanceSheetCharts('consolidated');
          }, 500);
        }
      },
      error => {
        console.error('Error fetching balance sheet consolidated data:', error);
        console.error('Error details:', error.error || error.message || error);
        this.balanceSheetConsolidatedData = [];
        this.balanceSheetConsolidatedHeaders = [];
        this.isLoadingBSConsolidated = false;
        this.isLoadingBS = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Initialize charts for Quarterly Profit & Loss
  initializeQuarterlyPLCharts(type: string) {
    const self = this;
    
    // Use jQuery to ensure DOM is ready
    $(function() {
      if (typeof Chart === 'undefined') {
        console.warn('Chart.js is not loaded');
        return;
      }

      // Wait for DOM to be ready
      setTimeout(function() {
        self.createQuarterlyPLCharts(type);
      }, 300);
    });
  }

  // Create Quarterly Profit & Loss Charts
  createQuarterlyPLCharts(type: string) {
    const data = type === 'standalone' ? this.arrangedDataStandalone : this.arrangedDataConsolidated;
    const headers = type === 'standalone' ? this.headerDatesStandalone : this.dateHeadersConsolidated;
    const canvasId = type === 'standalone' ? 'quarterlyPLAllFieldsChartStandalone' : 'quarterlyPLAllFieldsChartConsolidated';

    if (!data || data.length === 0 || !headers || headers.length === 0) {
      console.log('No data available for charts. Type:', type);
      return;
    }

    // Helper to parse value
    const parseValue = (val: any): number => {
      if (val === null || val === undefined || val === '' || val === '-') return 0;
      if (typeof val === 'number') return val;
      if (typeof val === 'string') {
        const cleaned = val.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '').trim();
        const num = parseFloat(cleaned);
        return isNaN(num) ? 0 : num;
      }
      return 0;
    };

    // Get all rows from data and create datasets for each
    const colors = [
      'rgba(54, 162, 235, 0.6)',   // Blue
      'rgba(75, 192, 192, 0.6)',    // Teal
      'rgba(255, 206, 86, 0.6)',    // Yellow
      'rgba(153, 102, 255, 0.6)',   // Purple
      'rgba(255, 99, 132, 0.6)',    // Pink
      'rgba(255, 159, 64, 0.6)',    // Orange
      'rgba(199, 199, 199, 0.6)',   // Gray
      'rgba(83, 102, 255, 0.6)',    // Indigo
      'rgba(255, 99, 71, 0.6)',     // Tomato
      'rgba(50, 205, 50, 0.6)',     // Lime Green
      'rgba(255, 20, 147, 0.6)',    // Deep Pink
      'rgba(0, 191, 255, 0.6)'      // Deep Sky Blue
    ];

    const borderColors = [
      'rgba(54, 162, 235, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 99, 132, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(199, 199, 199, 1)',
      'rgba(83, 102, 255, 1)',
      'rgba(255, 99, 71, 1)',
      'rgba(50, 205, 50, 1)',
      'rgba(255, 20, 147, 1)',
      'rgba(0, 191, 255, 1)'
    ];

    // Create datasets for all rows
    const datasets = data.map((row: any, index: number) => {
      const values = headers.map(header => parseValue(row[header]));
      return {
        label: row.label || `Metric ${index + 1}`,
        data: values,
        backgroundColor: colors[index % colors.length],
        borderColor: borderColors[index % borderColors.length],
        borderWidth: 1
      };
    });

    // Create single chart with all fields
    this.createPLChart(
      canvasId,
      'Quarterly Profit & Loss - All Metrics',
      headers,
      datasets
    );
  }

  // Helper method to create Profit & Loss charts
  createPLChart(canvasId: string, title: string, labels: string[], datasets: any[]) {
    const canvasElement = $('#' + canvasId);
    if (!canvasElement.length) {
      console.warn('Canvas element not found: ' + canvasId);
      return;
    }

    const canvas = canvasElement[0] as HTMLCanvasElement;
    if (!canvas) {
      return;
    }

    // Destroy existing chart if it exists
    const existingChart = (canvas as any).chart;
    if (existingChart) {
      existingChart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }

    try {
      const chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: datasets.map(ds => ({
            label: ds.label,
            data: ds.data,
            backgroundColor: ds.backgroundColor,
            borderColor: ds.borderColor,
            borderWidth: 1
          }))
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          legend: {
            display: true,
            position: 'top'
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem: any, data: any) {
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toLocaleString('en-IN');
              }
            }
          }
        }
      });

      // Store chart reference
      (canvas as any).chart = chart;
    } catch (error) {
      console.error('Error creating chart for ' + canvasId + ':', error);
    }
  }

  // Initialize charts for Annual Profit & Loss
  initializeAnnualPLCharts(type: string) {
    const self = this;
    
    // Use jQuery to ensure DOM is ready
    $(function() {
      if (typeof Chart === 'undefined') {
        console.warn('Chart.js is not loaded');
        return;
      }

      // Wait for DOM to be ready
      setTimeout(function() {
        self.createAnnualPLCharts(type);
      }, 300);
    });
  }

  // Create Annual Profit & Loss Charts
  createAnnualPLCharts(type: string) {
    const data = type === 'standalone' ? this.plAnnualDataStandalone : this.plAnnualDataConsolidated;
    const headers = type === 'standalone' ? this.plAnnualStandaloneHeaders : this.plAnnualConsolidatedHeaders;
    const canvasId = type === 'standalone' ? 'annualPLAllFieldsChartStandalone' : 'annualPLAllFieldsChartConsolidated';

    if (!data || data.length === 0 || !headers || headers.length === 0) {
      console.log('No annual data available for charts. Type:', type);
      return;
    }

    // Helper to parse value
    const parseValue = (val: any): number => {
      if (val === null || val === undefined || val === '' || val === '-') return 0;
      if (typeof val === 'number') return val;
      if (typeof val === 'string') {
        const cleaned = val.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '').trim();
        const num = parseFloat(cleaned);
        return isNaN(num) ? 0 : num;
      }
      return 0;
    };

    // Color palette for all metrics
    const colors = [
      'rgba(54, 162, 235, 0.6)',   // Blue
      'rgba(75, 192, 192, 0.6)',    // Teal
      'rgba(255, 206, 86, 0.6)',    // Yellow
      'rgba(153, 102, 255, 0.6)',   // Purple
      'rgba(255, 99, 132, 0.6)',    // Pink
      'rgba(255, 159, 64, 0.6)',    // Orange
      'rgba(199, 199, 199, 0.6)',   // Gray
      'rgba(83, 102, 255, 0.6)',    // Indigo
      'rgba(255, 99, 71, 0.6)',     // Tomato
      'rgba(50, 205, 50, 0.6)',     // Lime Green
      'rgba(255, 20, 147, 0.6)',    // Deep Pink
      'rgba(0, 191, 255, 0.6)'      // Deep Sky Blue
    ];

    const borderColors = [
      'rgba(54, 162, 235, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 99, 132, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(199, 199, 199, 1)',
      'rgba(83, 102, 255, 1)',
      'rgba(255, 99, 71, 1)',
      'rgba(50, 205, 50, 1)',
      'rgba(255, 20, 147, 1)',
      'rgba(0, 191, 255, 1)'
    ];

    // Create datasets for all rows
    const datasets = data.map((row: any, index: number) => {
      // Get label - could be row.label or row[0]
      const label = row.label || row[0] || `Metric ${index + 1}`;
      
      // Skip section headings or empty rows
      if (!label || label.trim() === '' || label.includes('ASSETS') || label.includes('EQUITY')) {
        return null;
      }
      
      const values = headers.map(header => parseValue(row[header]));
      return {
        label: label,
        data: values,
        backgroundColor: colors[index % colors.length],
        borderColor: borderColors[index % borderColors.length],
        borderWidth: 1
      };
    }).filter((ds: any) => ds !== null); // Remove null entries

    if (datasets.length === 0) {
      console.log('No valid datasets created for annual charts');
      return;
    }

    // Format year headers for display
    const formattedHeaders = headers.map(header => this.formatYearHeader(header) || header);

    // Create single chart with all fields
    this.createPLChart(
      canvasId,
      'Annual Profit & Loss - All Metrics',
      formattedHeaders,
      datasets
    );
  }

  // Initialize charts for Balance Sheet
  initializeBalanceSheetCharts(type: string) {
    const self = this;
    
    // Use jQuery to ensure DOM is ready
    $(function() {
      if (typeof Chart === 'undefined') {
        console.warn('Chart.js is not loaded');
        return;
      }

      // Wait for DOM to be ready
      setTimeout(function() {
        self.createBalanceSheetCharts(type);
      }, 300);
    });
  }

  // Create Balance Sheet Charts
  createBalanceSheetCharts(type: string) {
    const data = type === 'standalone' ? this.balanceSheetStandaloneData : this.balanceSheetConsolidatedData;
    const headers = type === 'standalone' ? this.balanceSheetStandaloneHeaders : this.balanceSheetConsolidatedHeaders;
    const canvasId = type === 'standalone' ? 'balanceSheetAllFieldsChartStandalone' : 'balanceSheetAllFieldsChartConsolidated';

    if (!data || data.length === 0 || !headers || headers.length === 0) {
      console.log('No balance sheet data available for charts. Type:', type);
      return;
    }

    // Helper to parse value
    const parseValue = (val: any): number => {
      if (val === null || val === undefined || val === '' || val === '-') return 0;
      if (typeof val === 'number') return val;
      if (typeof val === 'string') {
        const cleaned = val.replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, '').trim();
        const num = parseFloat(cleaned);
        return isNaN(num) ? 0 : num;
      }
      return 0;
    };

    // Color palette for all metrics
    const colors = [
      'rgba(54, 162, 235, 0.6)',   // Blue
      'rgba(75, 192, 192, 0.6)',    // Teal
      'rgba(255, 206, 86, 0.6)',    // Yellow
      'rgba(153, 102, 255, 0.6)',   // Purple
      'rgba(255, 99, 132, 0.6)',    // Pink
      'rgba(255, 159, 64, 0.6)',    // Orange
      'rgba(199, 199, 199, 0.6)',   // Gray
      'rgba(83, 102, 255, 0.6)',    // Indigo
      'rgba(255, 99, 71, 0.6)',     // Tomato
      'rgba(50, 205, 50, 0.6)',     // Lime Green
      'rgba(255, 20, 147, 0.6)',    // Deep Pink
      'rgba(0, 191, 255, 0.6)',     // Deep Sky Blue
      'rgba(255, 165, 0, 0.6)',     // Orange
      'rgba(138, 43, 226, 0.6)',    // Blue Violet
      'rgba(34, 139, 34, 0.6)'      // Forest Green
    ];

    const borderColors = [
      'rgba(54, 162, 235, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 99, 132, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(199, 199, 199, 1)',
      'rgba(83, 102, 255, 1)',
      'rgba(255, 99, 71, 1)',
      'rgba(50, 205, 50, 1)',
      'rgba(255, 20, 147, 1)',
      'rgba(0, 191, 255, 1)',
      'rgba(255, 165, 0, 1)',
      'rgba(138, 43, 226, 1)',
      'rgba(34, 139, 34, 1)'
    ];

    // Create datasets for all rows
    const datasets = data.map((row: any, index: number) => {
      // Get label - could be row.label or row[0]
      const label = row.label || row[0] || `Metric ${index + 1}`;
      
      // Skip section headings or empty rows
      if (!label || label.trim() === '' || 
          (label.toUpperCase().includes('ASSETS') && !label.toUpperCase().includes('TOTAL')) ||
          (label.toUpperCase().includes('EQUITY') && !label.toUpperCase().includes('TOTAL') && !label.toUpperCase().includes('SHARE') && !label.toUpperCase().includes('RESERVES'))) {
        return null;
      }
      
      const values = headers.map(header => parseValue(row[header]));
      return {
        label: label,
        data: values,
        backgroundColor: colors[index % colors.length],
        borderColor: borderColors[index % borderColors.length],
        borderWidth: 1
      };
    }).filter((ds: any) => ds !== null); // Remove null entries

    if (datasets.length === 0) {
      console.log('No valid datasets created for balance sheet charts');
      return;
    }

    // Format year headers for display
    const formattedHeaders = headers.map(header => this.formatYearHeader(header) || header);

    // Create single chart with all fields
    this.createPLChart(
      canvasId,
      'Balance Sheet - All Metrics',
      formattedHeaders,
      datasets
    );
  }
}

